import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { computed, ref } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import { between, maxValue } from "@vuelidate/validators";
import { withPastDate, withValidDate } from "@Shared/@Utils/validation-rules";
import { minValueNotRequired } from "@Shared/@Utils/new-validation-rules";
import { AddressRules } from "./goalsPageValidator";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { otherPropertiesBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/other-properties/otherPropertiesBindingsAndVisibilities";
import { useApplicantHelpers } from "../pages/applicants/useApplicantHelpers";
import { camelCase, mapKeys, merge, omit } from "lodash";
export const otherPropertyValidator = (applicantIndex, otherPropertyIndex, {
  lazy = false
} = {}) => {
  const {
    bindings
  } = otherPropertiesBindingsAndVisibilities(applicantIndex, otherPropertyIndex, ref("0"));
  const {
    purchasePrice,
    estimatedValue,
    purchaseDate,
    address,
    feesIncludeHeat,
    heating,
    maintenanceFees,
    percOfTotalMaintFees,
    propertyTaxes,
    hydro,
    insurance,
    interest,
    management,
    monthlyIncome,
    occupancy,
    others,
    repairs,
    rentalIncomeOptions,
    rentalIncomeOptionsPercent
  } = bindings;
  const applicantPrefix = computed(() => {
    return applicantIndex.value ? "applicantOtherProperties" : "otherProperties";
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = () => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(getApplicantIdByIndex(applicantIndex.value));
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, otherPropertyPageRules, applicantPrefix.value, {
      "co-applicants": applicantIndex.value - 1,
      "other-properties": otherPropertyIndex.value
    });
  });
  const v$ = useVuelidate(rules, {
    purchasePrice,
    estimatedValue,
    purchaseDate,
    address,
    feesIncludeHeat,
    heating,
    maintenanceFees,
    percOfTotalMaintFees,
    propertyTaxes,
    hydro,
    insurance,
    interest,
    management,
    monthlyIncome,
    occupancy,
    others,
    repairs,
    rentalIncomeOptions,
    rentalIncomeOptionsPercent
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const otherPropertyPageRules = {
  purchasePrice: {
    validPurchasePrice: ({
      isRequired
    }) => minValueNotRequired(1000, isRequired),
    maxValue: maxValue(1000000000000)
  },
  estimatedValue: {
    validEstimatedValue: ({
      isRequired
    }) => minValueNotRequired(1000, isRequired),
    maxValue: maxValue(1000000000000)
  },
  purchaseDate: {
    withPastDate: () => withPastDate,
    withValidDate: () => withValidDate
  },
  address: AddressRules,
  feesIncludeHeat: {},
  heating: {
    between: between(0, 1000000000000)
  },
  maintenanceFees: {
    between: between(0, 1000000000000)
  },
  percOfTotalMaintFees: {},
  propertyTaxes: {
    between: between(1, 1000000000000)
  },
  hydro: {
    between: between(0, 1000000000000)
  },
  insurance: {
    between: between(0, 1000000000000)
  },
  interest: {
    between: between(0, 1000000000000)
  },
  management: {
    between: between(0, 1000000000000)
  },
  monthlyIncome: {
    between: between(0, 1000000000000)
  },
  occupancy: {},
  others: {
    between: between(0, 1000000000000)
  },
  repairs: {
    between: between(0, 1000000000000)
  },
  rentalIncomeOptions: {},
  rentalIncomeOptionsPercent: {}
};
export const otherPropertiesValidator = ({
  lazy = false
} = {}) => {
  const {
    GET_SCHEMA_RULES_BY_PATH
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH]);
  const {
    allOtherProperties: otherProperties
  } = useApplicantHelpers();
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const allOtherProperties = computed(() => {
    var _context;
    return _flatMapInstanceProperty(_context = otherProperties.value).call(_context, item => isApplicantVisibleFromFillOut(item.applicantId) ? mapKeys(omit(merge(item, _objectSpread(_objectSpread(_objectSpread({}, item["property-costs"]), item["property-details"]), item["property-rental"])), "property-costs", "property-details", "property-rental"), (_value, key) => camelCase(key)) : []);
  });
  const getRules = () => {
    var _context2;
    const mainApplicantRules = index => getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, otherPropertyPageRules, "applicantOtherProperties", {
      "other-properties": index
    });
    const coApplicantRules = (applicantIndex, index) => getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, otherPropertyPageRules, "otherProperties", {
      "co-applicants": applicantIndex,
      "other-properties": index
    });
    return _reduceInstanceProperty(_context2 = allOtherProperties.value).call(_context2, (acc, otherProperty, index) => {
      acc[index] = otherProperty.applicantIndex ? coApplicantRules(otherProperty.index, otherProperty.otherPropertyIndex) : mainApplicantRules(otherProperty.otherPropertyIndex);
      return acc;
    }, {});
  };
  const rules = computed(getRules);
  const v$ = useVuelidate(rules, allOtherProperties, {
    $scope: "otherProperty",
    $lazy: lazy
  });
  return {
    v$
  };
};